import Vue from 'vue'
import AudioVisual from './plugin'

Vue.use(AudioVisual)
